<template>
  <v-breadcrumbs
    class="zoox-component zoox-breadcrumbs"
    :class="{dark}"
    :items="appliedItems"
    :dark="dark"
  >
    <template #item="{item}">
      <slot name="item" :item="item">
        <li class="zoox-breadcrumbs-text">
          <div
            v-ripple="!item.disabled"
            class="v-breadcrumbs__item"
            tabindex="0"
            :class="{disabled: item.disabled, expand: item.isExpansion}"
            @keydown.enter="onClick(item)"
            @click="onClick(item)"
          >
            {{ item.text }}
          </div>
        </li>
      </slot>
    </template>

    <template #divider>
      <slot name="divider">
        <z-icon :dark="dark"> $keyboard_arrow_right_rounded</z-icon>
      </slot>
    </template>
  </v-breadcrumbs>
</template>

<script>
/**
 * Componente geralmente utilizado para indicar uma rota de navegação para o usuário.
 *
 * @displayName Breadcrumbs
 */
export default {
  name: 'ZBreadcrumbs',
  props: {
    /**
     * Define os itens do breadcrumbs
     *
     * @typedef {Object} {text: string, disabled: boolean, active: boolean}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Flag para indicar o uso de dark
     */
    dark: {
      type: Boolean,
      default: false,
    },

    maxItems: {
      type: Number,
      default: 5,
    },

    expanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      appliedItems: [],
    }
  },

  computed: {
    shouldCollapse() {
      return this.items.length > this.maxItems
    },
  },

  watch: {
    //controla o collapse ao alterar o maxItems e no primeiro render
    shouldCollapse: {
      handler(value) {
        if (value) {
          this.collapseItems()
        } else {
          this.expandItems()
        }
      },

      immediate: true,
    },

    //controla o collapse ao alterar o expanded (permite controlar o collapse externamente)
    expanded: {
      handler(value) {
        if (value) {
          this.expandItems()
        } else {
          this.collapseItems()
        }
      },
    },

    //controla o collapse ao alterar o items
    items: {
      handler() {
        if (this.shouldCollapse) {
          this.collapseItems()
        } else {
          this.expandItems()
        }
      },

      immediate: true,
    },
  },

  methods: {
    onClick(item) {
      if (item.isExpansion) {
        this.expandItems()
        return
      }

      if (item.disabled) return

      /**
       *  Evento emitido ao clicar em um dos links
       *  @property {Object} item - Objeto referente ao item clicado
       */
      this.$emit('click', item)
    },

    expandItems() {
      this.appliedItems = this.items
      this.$emit('update:expanded', true)
    },

    collapseItems() {
      const start = this.items[0]
      const end = this.items[this.items.length - 1]

      this.appliedItems = [start, {text: '...', isExpansion: true}, end]

      this.$emit('update:expanded', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-breadcrumbs {
  &.dark {
    .zoox-breadcrumbs-text {
      color: var(--white) !important;
    }
  }
}
.zoox-breadcrumbs-text {
  cursor: pointer;
  color: var(--primary);

  &:last-child {
    font-weight: bold;
  }

  &.disabled {
    cursor: not-allowed;
    color: #ccc;
  }

  &.expand {
    color: var(--black-500);
  }
}
</style>
